import { Alert, Box, Typography } from "@mui/material";
import React from "react";
import useCategoryChecker from "../hooks/useCategoryChecker";
import MuPb from "../widgets/MuPb";
import { getErrorResponse } from "../utils/util";

const ProductCategoriesChecker = ({ id }) => {
  const { data, isLoading, isError, error } = useCategoryChecker(id);
  if (isLoading) return <MuPb />;
  if (isError) return <Alert severity="error">{getErrorResponse(error)}</Alert>;

  return (
    <Box>
      {data.exists ? (
        <>
          <Typography gutterBottom>
            Product categories already uploaded
          </Typography>
          <a href={`/product-categories-view`} target="_blank">
            <Typography mt={1} mb={2}>
              Check Product Categories
            </Typography>
          </a>
        </>
      ) : (
        <>
          <Typography gutterBottom>
            Product categories not uploaded yet
          </Typography>
          <a href={`/choose-category-options`} target="_blank">
            <Typography mt={1} mb={2}>
              Upload Product Categories
            </Typography>
          </a>
        </>
      )}
    </Box>
  );
};

export default ProductCategoriesChecker;
